import { render, staticRenderFns } from "./deleteConfirm.vue?vue&type=template&id=38a1b85a&scoped=true&"
import script from "./deleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./deleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./deleteConfirm.vue?vue&type=style&index=0&id=38a1b85a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1b85a",
  null
  
)

export default component.exports